import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// thunk function
export const fetchApiWeather = createAsyncThunk("weatheAPI", async (apiUrl) => {
    const response = await axios.get(apiUrl);
    let tempRespons = Math.round(response.data.main.temp - 273);
    let tempMax = Math.round(response.data.main.temp_max - 273);
    let tempMin = Math.round(response.data.main.temp_min - 273);
    let descriptionRes = response.data.weather[0].description;
    let iconRes = response.data.weather[0].icon;
    let cityRes = response.data.sys.country;
    return {
        temp: tempRespons,
        description: descriptionRes,
        max: tempMax,
        min: tempMin,
        city: cityRes,
        icon: `https://openweathermap.org/img/wn/${iconRes}@2x.png`,
    }
})
// create state weather
export const weatherAPISlice = createSlice({
    name: 'weatherAPI',
    initialState: {
        weatherData: {},
        isLoding: false,
    },
    reducers: {},
    extraReducers(builder){
        builder.addCase((fetchApiWeather.pending) ,(state) =>{
            state.isLoding = true;
        })
        .addCase((fetchApiWeather.fulfilled) ,(state, {payload}) =>{
            state.isLoding = false;
            state.weatherData = payload;
        })
        .addCase(fetchApiWeather.rejected, (state) => {
            state.isLoding = false;
        })
    }
})
export default weatherAPISlice.reducer;